// extracted by mini-css-extract-plugin
export default {"module":"cookie_module__nu-gD","close":"cookie_close__I-FwE","text":"cookie_text__7vLf2","detail":"cookie_detail__05vqb","confirm":"cookie_confirm__zBxha"};